import { RequiredAsterisk, FieldValidationErrorMsg } from '../../../../sitel/demon/ui/atoms/form';
export default function TextAreaReligious({ labelText, id, register, errors, showIsRequired, defaultValues }) {
  //If I have values, this is no longer an active form element
  if(defaultValues[id] && defaultValues[id].length>0){
    return (
      <div className='form-group row align-items-start py-3 p-md-2'>
        <label className='col-md-6 col-form-label' style={{ paddingTop: 0 }}>
          {labelText}
        </label>
        <div className='col-md-6'>
          <textarea className='form-control' id={id} rows='4' value={defaultValues[id]} disabled={true} {...register(id)}></textarea>
          <FieldValidationErrorMsg field={id} errors={errors} />
        </div>
      </div>
    );  
  } else {
    return (
      <div className='form-group row align-items-start py-3 p-md-2'>
        <label htmlFor={id} className='col-md-6 col-form-label' style={{ paddingTop: 0 }}>
          {labelText}
          {showIsRequired && <RequiredAsterisk />}
        </label>
        <div className='col-md-6'>
          <textarea className='form-control' id={id} rows='4' {...register(id)}></textarea>
          <FieldValidationErrorMsg field={id} errors={errors} />
        </div>
      </div>
    );  
  }
}
